// @flow
import React from 'react';
import { flow, map, getOr, cond } from 'lodash/fp';
import { ErrorMessage } from './graphql-errors.styles';

export default cond([
  [getOr(0, 'error.graphQLErrors.length'), flow(
    getOr([], 'error.graphQLErrors'),
    map(({ message }, i) => <ErrorMessage key={message}>{message}</ErrorMessage>)
  )],
  [getOr(0, 'error.message'), () => <ErrorMessage>Something went wrong</ErrorMessage>],
  [() => true, () => null]
])



// WEBPACK FOOTER //
// ./src/components/graphql-errors/index.js